import React, { useState, useEffect } from 'react';
import Bluedots from '../../assets/images/blue_dotes.png';
import { contactApi } from '../../services/api';
import logger from '../../utils/logger';

function Contactform() {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        message: ''
    });

    const [submitted, setSubmitted] = useState(false);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        let timer;
        if (submitted || error) {
            timer = setTimeout(() => {
                setSubmitted(false);
                setError(null);
            }, 6000);
        }
        return () => clearTimeout(timer);
    }, [submitted, error]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const sanitize = (str) => {
        return str.replace(/<[^>]*>?/gm, '').trim(); // remove HTML tags and trim
      };
      
      const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);
        setLoading(true);
      
        // Sanitize inputs
        const sanitizedFormData = {
          name: sanitize(formData.name),
          email: formData.email.trim(),
          phone: sanitize(formData.phone),
          message: sanitize(formData.message)
        };
      
        // Basic email format validation (optional)
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(sanitizedFormData.email)) {
          setError('Email invalid.');
          setLoading(false);
          return;
        }
      
        try {
          await contactApi.submitContactForm(sanitizedFormData);
          setSubmitted(true);
          setFormData({ name: '', email: '', phone: '', message: '' });
        } catch (err) {
          logger.error('Failed to submit contact form', err);
          setError(err.message || '[Trimite Mesaj] A apărut o eroare. Încercați din nou mai târziu.');
        } finally {
          setLoading(false);
        }
      };
    
    return (
        <section className="contact_form white_text row_am" data-aos="fade-in" data-aos-duration={1500}>
            <div className="contact_inner">
                <div className="container">
                    <div className="dotes_blue">
                        <img src={Bluedots} alt="image" />
                    </div>
                    <div className="section_title" data-aos="fade-up" data-aos-duration={1500} data-aos-delay={100}>
                        <span className="title_badge">Scrie-ne un mesaj</span>
                        <h2>Cu ce te putem <span>ajuta?</span></h2>
                        <p>Completează formularul de mai jos, echipa noastră va lua legătura cu tine în cel mai scurt timp</p>
                    </div>

                    <form onSubmit={handleSubmit} data-aos="fade-up" data-aos-duration={1500}>
                        <div className="row">
                            <div className="col-md-4">
                                <div className="form-group">
                                    <input name="name" type="text" className="form-control" placeholder="Nume complet *" required value={formData.name} onChange={handleChange} />
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="form-group">
                                    <input name="email" type="email" className="form-control" placeholder="Email *" required value={formData.email} onChange={handleChange} />
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="form-group">
                                    <input name="phone" type="text" className="form-control" placeholder="Telefon *" required value={formData.phone} onChange={handleChange} />
                                </div>
                            </div>
                            <div className="col-md-12">
                                <div className="form-group">
                                    <textarea name="message" className="form-control" placeholder="Mesaj *" required value={formData.message} onChange={handleChange}></textarea>
                                </div>
                            </div>
                            <div className="col-md-8">
                                <div className="coustome_checkbox">
                                    <label htmlFor="term_checkbox">
                                        <input type="checkbox" id="term_checkbox" />
                                        <span className="checkmark" /> Sunt de acord să primesc emailuri, mesaje promoționale și newsletter
                                    </label>
                                </div>
                            </div>
                            <div className="col-md-4 text-right">
                                <div className="btn_block">
                                    <button type="submit" className="btn puprple_btn ml-0 color-lumo-orange">{loading ? 'Se trimite...' : 'Trimite'}</button>
                                    <div className="btn_bottom border-color-lumo-orange" />
                                </div>
                            </div>
                        </div>
                    </form>
                    <div className='info-message' data-aos="fade-up" data-aos-duration={1500}>
                        {submitted && <p className="mt-3 text-success">Mesajul a fost trimis cu succes!</p>}
                        {error && <p className="mt-3 text-danger">{error}</p>}
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Contactform;
